import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

/**
 * Página 404: muestra logo Tecno3F y redirige después de unos segundos.
 * @param {Object} props
 * @param {string} [props.redirectTo='/'] - Ruta a la que redirigir: '/' o '/dashboard'
 * @param {number} [props.redirectSeconds=5] - Segundos antes de redirigir (ej: 15)
 */
const NotFound = ({ redirectTo = '/', redirectSeconds = 15 }) => {
  const navigate = useNavigate();
  const [secondsLeft, setSecondsLeft] = useState(redirectSeconds);

  useEffect(() => {
    setSecondsLeft(redirectSeconds);
  }, [redirectSeconds]);

  useEffect(() => {
    const timer = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate(redirectTo, { replace: true });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [navigate, redirectTo]);

  const handleGoNow = () => {
    navigate(redirectTo, { replace: true });
  };

  const bgImage = `${process.env.PUBLIC_URL || ''}/images/campus.png`;

  return (
    <div className="not-found-page" style={{ backgroundImage: `url(${bgImage})` }}>
      <div className="not-found-card">
        <img
          src={`${process.env.PUBLIC_URL || ''}/images/logotecno3f.png`}
          alt="Tecno3F"
          className="not-found-logo"
        />
        <h1 className="not-found-title">404</h1>
        <p className="not-found-message">La URL es incorrecta o no existe.</p>
        <p className="not-found-redirect">
          Redirigiendo en {secondsLeft} segundo{secondsLeft !== 1 ? 's' : ''}…
        </p>
        <button type="button" className="not-found-btn" onClick={handleGoNow}>
          {redirectTo === '/dashboard' ? 'Ir al Dashboard' : 'Ir al inicio'}
        </button>
      </div>
    </div>
  );
};

export default NotFound;
